const config = {
  name: "solitude",
  features: {
    accessCodes: true,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    displayPromoTotalUses: true, // Display "Redemptions left" on promo code card
    mandatoryFields: true,
    userPhoneNumber: true,
    showAdaSupport: true,
    userName: true,
    userPostalCode: true
  },
  parkingSession: {
    // The same day, just before 6am
    cancelDaysBefore: 0,
    cancelTime: "06:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 6 am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 365
  }
}
export default config
